import { Component, ViewChild, OnInit, Input, OnChanges } from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { HttpService } from '../shared/services/http.service';
import { SessionHandler } from '../shared/services/session-handler.service';
import {usersResultService} from '../usersResultService';
// import { TooltipModule } from 'ng2-tooltip-directive';
import { MatDialog,MatDialogRef  } from '@angular/material/dialog';
import { dialogComponent } from '../dialog/dialog.component';
import { CommonService } from '../shared/services/common.service';
import { APPCONFIG } from '../config'
import { FormControl } from '@angular/forms';
import { HttpHeaders } from '@angular/common/http';
import { Page } from '../users/datatable/page';
import { OktaAuthStateService, OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { Inject } from '@angular/core';


@Component({
    selector: 'searchComponent',
    template: require('./search.component.html'),
    styles: [require('./search.component.scss'),require('../custom_style.scss')],
    providers: [HttpService, SessionHandler]

})
export class SearchComponent
 {
    
    ipp: number = 10;

    itemsPerPage= new FormControl(100);
    @ViewChild('tableWrapper') tableWrapper;
    @ViewChild(DatatableComponent) table: DatatableComponent;
    searchParameter:string;
    searchEve: boolean = true;
    APPCONFIG;
    tableRows :any = [];
    page = new Page();
    public rows:any;
    dashboardData = [];
    temp = [];
    showTable:boolean = true;
    userData:any;
    dialogRef;
    reasonList:any;
    fileUrl:any;
    isApprover:boolean = false;
    showAction:boolean = false;
    isFS:boolean = false;
    isAdmin:boolean = false;
    public daterange: any = {};
    filters:any={};
    customFilters:any={};
    arrayKeys:any;
    showFilterList:boolean = false;
    userRole:any;
    isOTD:boolean = false;
    showLoader:boolean = false;
    siteId:any = undefined;
    private currentComponentWidth;
    rowToDel:string=null;
    params:string="";
    defaultPageLimit:number=10;
    //pageNumber:number=0;
    currentPage:number=1;
    documentData:any=[];
    documentDataCopy:any=[];
    stopIncrement:number=0;
     
    ngOnInit()
    {
        this.APPCONFIG =APPCONFIG;
        this.activatedRoute.queryParams.subscribe((params: Params) => {
            this.searchParameter = params['searchParameter'];
          });
          if(this.searchParameter)
          {
              this.paginationOnLoading()
          }
         
    }

   
        
   search(value: string)
    {
         this.searchParameter=value;
         this.paginationOnLoading();
    }
    
     paginationOnLoading()
     {
        
         let token = localStorage.getItem('userEmail');
         let accessToken = localStorage.getItem('accessToken'); // <-- get accessToken from localStorage
         var httpOptions = {
           headers : new HttpHeaders({
                 'Content-Type': 'application/json',
                //  'googleEmailIdocumentDatad': token
                'Authorization': `Bearer ${accessToken}` // <-- add Authorization header

             })
         
         };
         let offset = (this.currentPage - 1) * this.defaultPageLimit;
   
         this.showLoader = true;
this.http.getRequestWithHeader('documentsServiceDocs/getDocument?parameter='+ this.searchParameter+'&limit='+ this.defaultPageLimit +'&offset='+offset, httpOptions).subscribe(
             res => {
                            const report_json = res['dataMap'];    
                            this.documentData = report_json.data;
                            this.stopIncrement = 0;
        if(this.documentData.length == 0 && this.currentPage > 1)
        {
          this.stopIncrement = 1;
          this.currentPage--;
        }
                     for(let i=0;i<this.documentData.length;i++)
                     { 
                        let region=(this.documentData[i]['region']!=null)?"region="+this.documentData[i]['region']:'';
                        let country=(this.documentData[i]['country']!=null)?"country="+this.documentData[i]['country']:'';
                        let userName=(this.documentData[i]['userName']!=null)?"userName="+this.documentData[i]['userName']:'';
                        let userId=(this.documentData[i]['userId']!=null)?"userId="+this.documentData[i]['userId']:'';
                        let consumerId=(this.documentData[i]['consumerId']!=null)?"consumerId="+this.documentData[i]['consumerId']:'';
                        let transactionId=(this.documentData[i]['transactionId']!=null)?"transactionId="+this.documentData[i]['transactionId']:'';
                        let applianceId=(this.documentData[i]['applianceId']!=null)?"applianceId="+this.documentData[i]['applianceId']:'';
                        let language=(this.documentData[i]['language']!=null)?"language="+this.documentData[i]['language']:'';
                        let documentSource=(this.documentData[i]['documentSource']!=null)?"documentSource="+this.documentData[i]['documentSource']:'';
                        let attachmentType=(this.documentData[i]['attachmentType']!=null)?"attachmentType="+this.documentData[i]['attachmentType']:'';
                        let system=(this.documentData[i]['system']!=null)?"system="+this.documentData[i]['system']:'';
                        this.documentData[i]['storageFileName']=[region,country,userName,userId,consumerId,transactionId,applianceId,language,documentSource,attachmentType,system];
                        this.documentData[i]['storageFileName']=this.documentData[i]['storageFileName'].filter(Boolean).join(',');
                     }


                    //  for(let data of this.documentData)
                    //  {
                    //     let region=(data['region']!=null)?"region="+data['region']:'';
                    //     let country=(data['country']!=null)?"country="+data['country']:'';
                    //     let userName=(data['userName']!=null)?"userName="+data['userName']:'';
                    //     let userId=(data['userId']!=null)?"userId="+data['userId']:'';
                    //     let consumerId=(data['consumerId']!=null)?"consumerId="+data['consumerId']:'';
                    //     let transactionId=(data['transactionId']!=null)?"transactionId="+data['transactionId']:'';
                    //     let applianceId=(data['applianceId']!=null)?"applianceId="+data['applianceId']:'';
                    //     let language=(data['language']!=null)?"language="+data['language']:'';
                    //     let documentSource=(data['documentSource']!=null)?"documentSource="+data['documentSource']:'';
                    //     let attachmentType=(data['attachmentType']!=null)?"attachmentType="+data['attachmentType']:'';
                    //     let system=(data['system']!=null)?"system="+data['system']:'';
                    //     data['storageFileName']=[region,country,userName,userId,consumerId,transactionId,applianceId,language,documentSource,attachmentType,system];
                    //     this.documentData.fileParameter=data['storageFileName']=data['storageFileName'].filter(Boolean).join(',');
                    //  }

                     

                    this.http.onEnd();
                    this.showLoader = false;
                     },
                 err => {
                     this.showLoader = false;
                     }
         );  
 

     }
       

    
     setpage(page)
     {
          this.currentPage = page;
          this.paginationOnLoading();
     }




     pageLimitation(limit:any): void
      {   
          this.defaultPageLimit=limit;
          this.currentPage=1;
          this.paginationOnLoading();
     }






















    //  search(value: string)
    //  {
    //       this.searchParameter=value;
    //       this.onSubmit();
    //  }


    onSubmit()
    {
        
       this.page.pageNumber = 0;
            this.page.size = 10;
            if(this.http.checkSession()){
         

                var today = new Date();
                this.daterange.date = today.getDate();
                if(today.getMonth() == 0 || today.getMonth() == 1){
                    this.daterange.start_mm = 12;
                    this.daterange.end_mm = 2;
                    this.daterange.startYear = today.getFullYear()-1;
                    this.daterange.endYear = today.getFullYear();
                } else {
                    this.daterange.start_mm = today.getMonth()-1;
                    this.daterange.end_mm = today.getMonth()+1;
                    this.daterange.startYear = today.getFullYear();
                    this.daterange.endYear = today.getFullYear();;
                }
              
               // this.filters['startDate']=this.daterange.startYear+'-'+this.daterange.start_mm+'-'+this.daterange.date;
               // this.filters['endDate']=this.daterange.endYear+'-'+this.daterange.end_mm+'-'+this.daterange.date;
                this.filters['offSet'] = this.page.pageNumber * this.page.size;
                this.findDocuments(this.filters);
                this.commonService.setData(null);

        }else{
            this.http.showSessionError();
        }
      
    }

    findDocuments(filter)
    {
         
        let token = localStorage.getItem('userEmail');
        let accessToken = localStorage.getItem('accessToken'); // <-- get accessToken from localStorage
        var httpOptions = {
          headers : new HttpHeaders({
                'Content-Type': 'application/json',
                // 'googleEmailId': token
                'Authorization': `Bearer ${accessToken}` // <-- add Authorization header
            })
        
        };
        
        this.showLoader = true;
        this.http.getRequestWithHeader('documentsServiceDocs/getDocuments?parameter='+ this.searchParameter, httpOptions).subscribe(
            res => {
                          
                           
                           const report_json = res['dataMap'];    
                           let items = report_json['documentList'];
                           var result = {'offSet':0,'limit':0,'items':items};
    
                        this.saveDashboardData(result,filter,items);
                         this.http.onEnd();
                        this.showLoader = false;
                    },
                err => {
                    this.showLoader = false;
                    }
        );  

    }
    ngAfterViewChecked() {
        // Check if the table size has changed,
        if (this.table && this.table.recalculate && (this.tableWrapper.nativeElement.clientWidth !== this.currentComponentWidth)) {
          this.currentComponentWidth = this.tableWrapper.nativeElement.clientWidth;
          this.table.recalculate();
        //   this.cdr.detectChanges();
        }
      }



      pageLimit(limit:any): void {

        this.changePageLimit(limit);
        this.table.limit = this.ipp;
        this.table.recalculate();

        setTimeout(() => {
            if (this.table.bodyComponent.temp.length <= 0) {
              this.table.offset = Math.floor((this.table.rowCount - 1) / this.table.limit);
            }
          });
        
      }

      private changePageLimit(limit: any): void {
        this.ipp = parseInt(limit, 10);
      }
    
    onPage(event) {
        this.table.limit = Number(this.itemsPerPage.value);
        // this.offset = event.offset;
      }

    constructor(private router: Router, private http:HttpService,private serverResultsService: usersResultService,private activatedRoute: ActivatedRoute
        ,private sessionHandler:SessionHandler,public dialog: MatDialog,private commonService : CommonService,@Inject(OKTA_AUTH) private oktaAuth: OktaAuth,
        private oktaAuthStateService: OktaAuthStateService
    ) {
        // Subscribe to Okta auth state and trigger data load after authentication
        this.oktaAuthStateService.authState$.subscribe(async (authState) => {
            if (authState.isAuthenticated) {
                const tokens = await this.oktaAuth.tokenManager.getTokens();
                localStorage.setItem('accessToken', tokens.accessToken?.accessToken || '');
                if (this.searchParameter) {
                    this.paginationOnLoading();
                }
            } else {
                this.router.navigateByUrl('/extra/login');
            }
        });
    }

    private async getAccessToken(): Promise<string> {
        let accessToken = localStorage.getItem('accessToken');
        if (!accessToken && this.oktaAuth) {
            const tokens = await this.oktaAuth.tokenManager.getTokens();
            accessToken = tokens.accessToken?.accessToken || '';
            if (accessToken) {
                localStorage.setItem('accessToken', accessToken);
            }
        }
        return accessToken || '';
    }


        public reloadData(){
       
            //this.getDashboardData(this.filters);
            this.findDocuments(this.filters);
        }
      
    
        public getDashboardData(filter){
            
            let token = localStorage.getItem('userEmail');
            let accessToken = localStorage.getItem('accessToken'); // <-- get accessToken from localStorage
        var httpOptions = {
          headers : new HttpHeaders({
                'Content-Type': 'application/json',
                // 'googleEmailId': token
                'Authorization': `Bearer ${accessToken}` // <-- add Authorization header    
            })
        
        };
        
        this.http.getRequestWithHeader('documentsServiceDocs/getDocuments?parameter='+ this.searchParameter, httpOptions).subscribe(
            res =>  {
                        if(res['message'] == 'error_occured'){
        
                            this.showLoader = false;
                
                            this.http.onEnd();
                            this.dialogRef = this.dialog.open(dialogComponent);
                            this.dialogRef.componentInstance.msg = res['exp']['message'];
                
                            this.dialogRef.afterClosed().subscribe(result => {
                                window.location.href = '#/app/users/list';
                            });
                            return;
                         }
        
        
                        const report_json = res['dataMap'];                 
                         let items = report_json['usersList'];
                        var result = {'offSet':0,'limit':0,'items':items};
    
                         this.saveDashboardData(result,filter,items);
                       
                        this.http.onEnd();
                        this.showLoader = false;
                        // this.buildForm();
        
        
                        },
                        err => {
                            this.dialogRef = this.dialog.open(dialogComponent);
                            this.dialogRef.componentInstance.msg = 'Failed to retrieve data.';
                            this.showLoader = false;
                            this.http.onEnd();
                            }
                );  
              }



              public rowToDelete(userId){
                this.rowToDel = userId;
            }
            
            public deleteUser(){
            if(this.rowToDel == null){
                    return;
                }
    
        const user = {'id':this.rowToDel};
        // console.log(user);
    
        // let body = JSON.stringify(user);
        this.showLoader = true;
    
        let token = localStorage.getItem('userEmail');
        let accessToken = localStorage.getItem('accessToken'); // <-- get accessToken from localStorage
        const httpOptions = {
          headers : new HttpHeaders({
                'Content-Type': 'application/json',
                // 'googleEmailId': token
                'Authorization': `Bearer ${accessToken}` // <-- add Authorization header
            }) };
        this.http.postRequestWithHeader(user,'users/delete',httpOptions).subscribe(
            res => { this.deleteUserResponse(res); 
            
            },
            err => { this.http.onEnd(); 
                this.showLoader = false;
    
            }
        );
     }
    
     public deleteUserResponse(res) {
        this.rowToDel = null;
        // var res = JSON.parse(res['_body']);
            if(res && res.message == 'success'){
              
                this.showLoader = false;
    
                this.http.onEnd();
                this.dialogRef = this.dialog.open(dialogComponent);
               
                    this.dialogRef.componentInstance.msg = "User deleted successfully.";
                this.dialogRef.afterClosed().subscribe(result => {
                this.reloadData();
                });
            }else if(res && res.message == 'error_occured'){
    
                this.showLoader = false;
    
                this.http.onEnd();
                this.dialogRef = this.dialog.open(dialogComponent);
                this.dialogRef.componentInstance.msg = res.exp.message;
    
            
             } else {
                this.showLoader = false;
    
                this.dialogRef = this.dialog.open(dialogComponent);
                this.dialogRef.componentInstance.msg = 'Not able to perform action. Please try again.';
                this.http.onEnd();
            }
        }
        public saveDashboardData(res,filter,items) {
            
                // if(res.status == 'Success') {
                if(res && Object.keys(res).length > 0 ){
                    this.dashboardData = res;
                    this.rows=[];
                    this.rows['offSet'] = res.offSet;
                    if(this.dashboardData && Object.keys(this.dashboardData).length > 0 ) {
                        if(this.dashboardData['items']) {
                            let totalCount = 0;
                        if(parseInt(res.offSet) == 0) {
                            localStorage.setItem('totalCount',res.itemCount);
                            totalCount = parseInt(res.itemCount);
                        } else {
                            totalCount = parseInt(localStorage.getItem('totalCount'));
                        }
                        this.rows['total_count'] = totalCount;
                        
                        for (let data in this.dashboardData['items']) {
                            
                        let region=(this.dashboardData['items'][data]['region']!=null)?"region="+this.dashboardData['items'][data]['region']:'';
                        let country=(this.dashboardData['items'][data]['country']!=null)?"country="+this.dashboardData['items'][data]['country']:'';
                        let userName=(this.dashboardData['items'][data]['userName']!=null)?"userName="+this.dashboardData['items'][data]['userName']:'';
                        let userId=(this.dashboardData['items'][data]['userId']!=null)?"userId="+this.dashboardData['items'][data]['userId']:'';
                        let consumerId=(this.dashboardData['items'][data]['consumerId']!=null)?"consumerId="+this.dashboardData['items'][data]['consumerId']:'';
                        let transactionId=(this.dashboardData['items'][data]['transactionId']!=null)?"transactionId="+this.dashboardData['items'][data]['transactionId']:'';
                        let applianceId=(this.dashboardData['items'][data]['applianceId']!=null)?"applianceId="+this.dashboardData['items'][data]['applianceId']:'';
                        let language=(this.dashboardData['items'][data]['language']!=null)?"language="+this.dashboardData['items'][data]['language']:'';
                        let documentSource=(this.dashboardData['items'][data]['documentSource']!=null)?"documentSource="+this.dashboardData['items'][data]['documentSource']:'';
                        let attachmentType=(this.dashboardData['items'][data]['attachmentType']!=null)?"attachmentType="+this.dashboardData['items'][data]['attachmentType']:'';
                        let system=(this.dashboardData['items'][data]['system']!=null)?"system="+this.dashboardData['items'][data]['system']:'';



                    //    var arr = ['Hi', 'I', 'am', 'a', 'comma', 'separated', 'list']; arr.join(',');

                                this.rows[data] = {};
                                this.rows[data]['documentName'] = this.dashboardData['items'][data]['documentName']; 
                                this.rows[data]['documentUploadDate'] = this.dashboardData['items'][data]['documentUploadDate'];
                                this.rows[data]['documentSize'] = this.dashboardData['items'][data]['documentSize'];
                                this.rows[data]['urlMediaLink'] = this.dashboardData['items'][data]['urlMediaLink'];
     this.rows[data]['storageFileName']=[region,country,userName,userId,consumerId,transactionId,applianceId,language,documentSource,
        attachmentType,system];
        this.rows[data]['storageFileName']=this.rows[data]['storageFileName'].filter(Boolean).join(',');
        
                            }
                        this.showTable = true;
                        this.showLoader = false;
                        this.temp = this.rows;
                        //console.log(JSON.stringify(this.rows));
                        }
                    }
    
                //   this.updateAllFilter(true);
    
                    let finalRows = [];
                    for(let f in this.rows){
                        if(f != 'offSet' && f !='total_count' && this.rows[f]){
                            finalRows.push(this.rows[f]);
                        }
                        if(f == 'offSet'){
                            finalRows['offSet'] = this.rows['offSet'];
                        }
                        if(f == 'total_count'){
                            finalRows['total_count'] = this.rows['total_count'];
                        }
                    }
                    this.rows = finalRows;
                    this.setPage({ offset: this.rows['offSet']/this.page.size },finalRows,filter);
                    this.http.onEnd();
                }
            // } else {
            //     this.dialogRef = this.dialog.open(dialogComponent);
            //     this.dialogRef.componentInstance.msg = res.errorMessage;
            //     this.http.onEnd();
            // }
        }
    
    
        /**
        * Populate the table with new data based on the page number
        * @param page The page to select
        */


        
      downloadFile(url)
      {
        window.open(url, '_blank');
      }

        setPage(pageInfo,rows,filter){
            this.page.pageNumber = pageInfo.offset;
                if(rows.length != 0){
                    this.serverResultsService.getResults(this.page,rows).subscribe(pagedData => {
                        this.page = pagedData.page;
                        this.tableRows = pagedData.data;
                    if(!filter){
                        if(Object.keys(this.tableRows).length == 0 || !this.tableRows[0]['status']){
                            this.filters['offSet'] = this.page.pageNumber * this.page.size;
                            this.getDashboardData(this.filters);
                        }
                    }
                });
            } else {
                this.tableRows = [];
                this.page.totalElements = rows.length;
            }
        }
      
          
    public getLastWeek(){
        var today = new Date();
        var lastWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7);
        return lastWeek ;
    }
    
    
    
    
     

}